import React, { PropsWithChildren, useRef } from 'react';
import { IPqDataEntryFormProps } from '../../types/shared/PrequalificationDataEntry';
import './PqDataEntryForm.css';
import PqDataManagerProvider from './providers/PqDataManagerProvider';
import LoaderProvider from './providers/LoaderProvider';
import PagePropertiesProvider from './providers/PagePropertiesProvider';
import usePqdeSetup from './hooks/usePqdeSetup';
import HomeAddressErrorProvider from './providers/HomeAddressErrorProvider';
import PersonalInformationErrorProvider from './providers/PersonalInformationErrorProvider';
import HomeAddressProvider from './providers/HomeAddressProvider';
import PersonalInformationProvider from './providers/PersonalInformationProvider';
import { FormArea } from './components/FormArea/FormArea';

export const PqDataEntryFormEditConfig = {
    emptyLabel: 'Pq Data Entry Form',
    isEmpty: (props: PropsWithChildren<IPqDataEntryFormProps>) =>
        !props || !props.disclaimerDesktop,
};

const PqDataEntryForm = (
    props: PropsWithChildren<IPqDataEntryFormProps>,
): JSX.Element => {
    const pageRef = useRef<HTMLDivElement>(null);

    usePqdeSetup(pageRef, props.author);
    return (
        <div ref={pageRef} id='pq-data-entry-form' className='Container PqDataEntryForm__versionA !px-0'>
            <PagePropertiesProvider pagePropertiesFromAEM={props}>
                <PqDataManagerProvider>
                    <PersonalInformationProvider>
                        <HomeAddressProvider>
                            <PersonalInformationErrorProvider>
                                <HomeAddressErrorProvider>
                                    <LoaderProvider>
                                        <FormArea 
                                            cityStateRetrievalEnabled={props.cityStateRetrievalEnabled}
                                            formSubtitle={props.formSubtitle}
                                            id={props.id}
                                            version={props.version}
                                        />
                                    </LoaderProvider>
                                </HomeAddressErrorProvider>
                            </PersonalInformationErrorProvider>
                        </HomeAddressProvider>
                    </PersonalInformationProvider>
                </PqDataManagerProvider>
            </PagePropertiesProvider>
        </div>
    );
};

export default PqDataEntryForm;
